import { lazy } from 'react';

export const CommunicationPage = lazy(() => import('./CommunicationPage'));
